import { render, staticRenderFns } from "./form-header-submitted-preview.vue?vue&type=template&id=52fcba82&"
import script from "./form-header-submitted-preview.vue?vue&type=script&lang=js&"
export * from "./form-header-submitted-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "form-header-submitted-preview.vue"
export default component.exports